import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActionButtonComponent } from './action-button/action-button.component';
import { DisLikeBtnComponent } from './dis-like-btn/dis-like-btn.component';
import { DropdownMenuComponent } from './dropdown-menu/dropdown-menu.component';
import { NavTabsComponent } from './nav-tabs/nav-tabs.component';
import { PlayBtnComponent } from './play-btn/play-btn.component';
import { PlayBtnLibraryComponent } from './play-btn-library/play-btn-library.component';
import { PlayFromComponent } from './play-from/play-from.component';
import { SwitchButtonComponent } from './switch-button/switch-button.component';
import { ImagesModule } from '../images/images.module';
import { SharedModule } from '../../shared.module';
import { MatIconModule } from '@angular/material/icon';
import { ButtonComponent } from './button/button.component';
import { MatButtonModule } from '@angular/material/button';
import { IconRegistryModule } from 'src/app/utils/icon-registry.module';
import { MainButtonComponent } from './main-button/main-button.component';

@NgModule({
  declarations: [
    ActionButtonComponent,
    DisLikeBtnComponent,
    DropdownMenuComponent,
    NavTabsComponent,
    PlayBtnComponent,
    PlayBtnLibraryComponent,
    PlayFromComponent,
    SwitchButtonComponent,
    ButtonComponent,
    MainButtonComponent
  ],
  exports: [
    PlayBtnLibraryComponent,
    DropdownMenuComponent,
    PlayFromComponent,
    PlayBtnComponent,
    ActionButtonComponent,
    SwitchButtonComponent,
    ButtonComponent,
    MainButtonComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    ImagesModule,
    MatIconModule,
    MatButtonModule,
    IconRegistryModule
  ]
})
export class ButtonsModule { }
